export default __webpack_public_path__ + "static/media/hero-animation-04.40c3b8a2.svg";